<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Request a pod</h4>
    <i
      style="z-index: 1"
      class="bi bi-x-lg text-danger"
      color="warn"
      (click)="cancel()"
      title="Close"
    ></i>
  </div>

  <div class="modal-body" style="max-height: 75vh; overflow: auto">
    <form [formGroup]="podForm">
      <!-- <div class="form-container">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Namespace</mat-label>
          <mat-select formControlName="namespace">
            <mat-option *ngFor="let ns of namespaceOptions" [value]="ns">
              {{ ns }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="podForm.get('namespace')?.hasError('required')">
            Namespace is required
          </mat-error>
        </mat-form-field> -->

      <!-- Namespace -->
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Namespace</mat-label>
        <input
          type="text"
          matInput
          formControlName="namespace"
          [matAutocomplete]="autoNs"
          placeholder="e.g., default"
          cdkFocusInitial="false"
        />
        <mat-autocomplete #autoNs="matAutocomplete">
          <mat-option *ngFor="let ns of namespaceOptions" [value]="ns">
            {{ ns }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="podForm.get('namespace')?.hasError('required')">
          Namespace is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Pod Name</mat-label>
        <input
          matInput
          formControlName="name"
          placeholder="auto-generated if empty"
          cdkFocusInitial
        />
        <mat-error *ngIf="podForm.get('name')?.hasError('required')">
          Pod Name is required
        </mat-error>
        <mat-error *ngIf="podForm.get('name')?.hasError('pattern')">
          Pod Name must start with a lowercase letter and can only contain
          lowercase letters, numbers, and hyphens.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Container Image</mat-label>
        <mat-select formControlName="image">
          <mat-option *ngFor="let img of predefinedImages" [value]="img.value">
            {{ img.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        appearance="fill"
        class="full-width"
        *ngIf="podForm.get('image')?.value === 'custom'"
      >
        <mat-label>Custom Image</mat-label>
        <input
          matInput
          formControlName="customImage"
          placeholder="e.g., nginx:latest"
        />
        <mat-error *ngIf="podForm.get('customImage')?.hasError('required')">
          Custom image is required
        </mat-error>
      </mat-form-field>

      <div class="form-row">
       <mat-form-field appearance="fill" class="half-width">
        <mat-label>Select Nodes to create Pod on </mat-label>
        <mat-select formControlName="nodeNames" multiple>
          <mat-option [disabled]="nodeSelectionChange(node)" *ngFor="let node of depNodes" [value]="node">
            {{ node }}
          </mat-option>
        </mat-select>
      </mat-form-field>

        <mat-form-field appearance="fill" class="half-width">
          <mat-label>GPU Request/Limit</mat-label>
          <input
            type="text"
            matInput
            formControlName="gpu"
            [matAutocomplete]="autoGpu"
            placeholder="e.g., 1/1"
          />
          <mat-autocomplete #autoGpu="matAutocomplete">
            <mat-option *ngFor="let opt of gpuOptions" [value]="opt.value">
              {{ opt.label }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="podForm.get('gpu')?.hasError('invalidGpu')">
            GPU format must be like `1/1`, and left value must be less than
            right.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <!-- <mat-form-field appearance="fill" class="half-width">
            <mat-label>CPU Request/Limit</mat-label>
            <mat-select formControlName="cpu">
              <mat-option *ngFor="let opt of cpuOptions" [value]="opt.value">
                {{ opt.label }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->

        <mat-form-field appearance="fill" class="half-width">
          <mat-label>CPU Request/Limit</mat-label>
          <input
            type="text"
            matInput
            formControlName="cpu"
            [matAutocomplete]="autoCpu"
            placeholder="e.g., 500m/1000m"
          />
          <mat-autocomplete #autoCpu="matAutocomplete">
            <mat-option *ngFor="let opt of cpuOptions" [value]="opt.value">
              {{ opt.label }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="podForm.get('cpu')?.hasError('invalidCpu')">
            CPU format must be like `500m/1000m`, and left value must be less
            than right.
          </mat-error>
        </mat-form-field>

        <!-- <mat-form-field appearance="fill" class="half-width">
            <mat-label>Memory Request/Limit</mat-label>
            <mat-select formControlName="memory">
              <mat-option *ngFor="let opt of memoryOptions" [value]="opt.value">
                {{ opt.label }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->

        <!-- Memory -->
        <mat-form-field appearance="fill" class="half-width">
          <mat-label>Memory Request/Limit</mat-label>
          <input
            type="text"
            matInput
            formControlName="memory"
            [matAutocomplete]="autoMem"
            placeholder="e.g., 512Mi/1Gi"
          />
          <mat-autocomplete #autoMem="matAutocomplete">
            <mat-option *ngFor="let opt of memoryOptions" [value]="opt.value">
              {{ opt.label }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="podForm.get('memory')?.hasError('invalidMemory')">
            Memory format must be like `512Mi/1Gi`, and left value must be less
            than right.
          </mat-error>
        </mat-form-field>
      </div>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Additional packages to install</mat-label>
        <textarea
          matInput
          formControlName="commandSequence"
          placeholder="Enter package names"
          rows="3"
        ></textarea>
        <mat-hint
          >Please enter space seperated package names in a correct
          order</mat-hint
        >
      </mat-form-field>

      <!-- <div class="env-section">
        <div class="env-header">
          <h3>Environment Variables</h3>
          <button mat-icon-button color="primary" type="button" (click)="addEnvVar()">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <div formArrayName="env" class="env-vars">
          <div *ngFor="let env of envArray.controls; let i = index"
               [formGroupName]="i"
               class="env-row">
            <mat-form-field appearance="fill" class="env-key">
              <mat-label>Key</mat-label>
              <input matInput formControlName="name" placeholder="ENV_VAR_NAME">
            </mat-form-field>

            <mat-form-field appearance="fill" class="env-value">
              <mat-label>Value</mat-label>
              <input matInput formControlName="value" placeholder="value">
            </mat-form-field>

            <button mat-icon-button color="warn" type="button" (click)="removeEnvVar(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div> -->
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
      Close
    </button>
    <button type="button" class="btn btn-primary" (click)="createPod()">
      Submit
    </button>
  </div>
</div>

<ngx-spinner
  bdColor="rgba(0,0,0,0)"
  size="default"
  zIndex="1"
  color="var(--s-primary-color)"
  type="ball-spin"
  [fullScreen]="false"
  name="create-pod"
>
  <p>Creating pod...</p>
</ngx-spinner>

<ngx-spinner
  bdColor="rgba(0,0,0,0)"
  size="default"
  zIndex="1"
  color="var(--s-primary-color)"
  type="ball-spin"
  [fullScreen]="false"
  name="please-wait"
>
  <p>Please wait...</p>
</ngx-spinner>
